import { ChangeDetectionStrategy, Component, OnInit, inject, output, input } from '@angular/core';
import { FileDownloadWebService } from '../../../services/file/download.service';
import { PictureWebComponent } from '../picture/picture.component';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { IconWebComponent, LoaderWebComponent } from '@resident-nx/web/ui';
import { ImmomioIconName } from '@resident-nx/shared';
import { TranslatePipe } from '@ngx-translate/core';

export interface TicketAttachmentLoadedEvent {
  identifier: string;
  url: string;
  isRequested: boolean;
  isAlreadyRequested: boolean;
}

@Component({
  standalone: true,
  selector: 'rs-web-ticket-image-viewer',
  imports: [PictureWebComponent, AsyncPipe, LoaderWebComponent, IconWebComponent, TranslatePipe],
  templateUrl: './ticket-image-viewer.component.html',
  styleUrl: './ticket-image-viewer.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    role: 'button',
    tabindex: '0',
  },
})
export class TicketImageViewerComponent implements OnInit {
  protected readonly ImmomioIconName = ImmomioIconName;
  private downloadService = inject(FileDownloadWebService);

  ticketId = input<string>();
  attachmentIdentifier = input<string>();

  attachmentLoaded = output<TicketAttachmentLoadedEvent>();

  attachment$: Observable<{ url: string; isRequested: boolean; isAlreadyRequested: boolean }>;

  ngOnInit(): void {
    this.attachment$ = this.downloadService
      .downloadTicketAttachment(this.ticketId(), this.attachmentIdentifier())
      .pipe(
        tap(result =>
          this.attachmentLoaded.emit({
            identifier: this.attachmentIdentifier(),
            url: result.url,
            isRequested: result.isRequested,
            isAlreadyRequested: result.isAlreadyRequested,
          })
        )
      );
  }
}
